import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=bcfd0bfe"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"
import style0 from "./Station.vue?vue&type=style&index=0&id=bcfd0bfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports